module.exports = __webpack_public_path__ + "img/disaster-monster.1f54cb8d.svg";